//src/services/GoogleRegister.js
import { encryptAesGcm } from "./crypto_aes";
import { API_BASE_CLIENT as API_BASE, SECRET_KEY } from "../config/vars";

export const googleRegister = async ({ token, descriptions, password, service_ids = [] }) => {
    if (!SECRET_KEY) {
        return { ok: false, data: { detail: "Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)" } };
    }

    const encryptedPassword = await encryptAesGcm(SECRET_KEY, password);

    const response = await fetch(`${API_BASE}/login/client/google-register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            token,
            descriptions,
            password: encryptedPassword,
            service_id: Array.isArray(service_ids) && service_ids.length === 1 ? parseInt(service_ids[0]) : null,
            service_ids: Array.isArray(service_ids) ? service_ids.map((value) => parseInt(value)).filter((value) => Number.isFinite(value)) : [],
        }),
    });

    const data = await response.json();
    return { ok: response.ok, data };
};
